export const NavItems = [
  {
    link: '/',
    caption: 'Home',
  },

  {
    link: '/menu',
    caption: 'Menu',
  },

  {
    link: '/order',
    caption: 'Order',
    numberOfOrder: 0,
  },

  {
    link: '/ourservices',
    caption: 'Our Services',
  },
];
